/* @flow */

import { rem } from 'polished';

import { baseFontSize } from '@braindate/ui/lib/token/typography';

import type { ThemeFunction } from 'src/shared/app/base/types/themeTypes';

export default {
  root: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    margin: [0, 0, 60, 0],
  },
  eventName: {
    marginBottom: 20,
    color: ({ theme }: ThemeFunction) => theme.textColor,
    '& sup': {
      fontWeight: 600,
      fontSize: rem(5.25, baseFontSize),
    },
    '& i': {
      fontWeight: 300,
      fontSize: rem(12, baseFontSize),
    },
  },
  braindate: {
    textTransform: 'capitalize',
    fontSize: rem(14, baseFontSize),
    color: ({ theme }: ThemeFunction) => theme.secondaryTagTextColor,
    fontWeight: 700,
  },
  logo: {
    maxWidth: 105,
  },
};
